import { Col, Typography } from "@commonlibs";
import { RadioButtonGroup } from "ui/common/components/input/RadioButtonGroup/RadioButtonGroup";
import { RoleSelectorProps } from "./RoleSelector.types";

export default function RoleSelector({ roles, defaultRole, onChangeRole }: RoleSelectorProps) {
    function onRadioChange(value: string) {
        const role = roles.find((item) => item.value === value);
        onChangeRole(role!, role?.operations || []);
    }

    return (
        <Col gap={15}>
            <Typography variant="body2Strong" color="primary">
                Selecciona el tipo de rol
            </Typography>
            <RadioButtonGroup onChange={onRadioChange} defaultValue={defaultRole?.value} options={roles.map((item) => ({ ...item, label: item.name }))} />
        </Col>
    );
}
